/* eslint-disable no-nested-ternary */
/* eslint-disable no-undef-init */
import React, { useContext, useEffect, useState } from 'react';
import 'mapbox-gl/dist/mapbox-gl.css';
import { Button, ListTable, Typography } from 'design_system/src';
import { momentLocal } from 'models/shared/helpers/dates';

import { repossessionContext } from '../../RepossessionsContext';

import '../../recovery.scss';
import { CreateRouteSteps, TableInfo } from '../../Repossessions.constants';

export const FilterRepossessionsTable = () => {
	const {
		repossessionsData,
		recoveriesData,
		selectedMarkers,
		gpsLocations,
		tileLocations,
		setCreateRouteStep,
		selectedRepossessions,
		setSelectedRepossessions,
	} = useContext(repossessionContext);

	const [tableData, setTableData] = useState<TableInfo[]>([]);

	useEffect(() => {
		const data = Array.from(selectedMarkers).map((marker) => {
			const repossessions = repossessionsData[marker];
			const recoveries = recoveriesData[marker];
			const lastRecovery = recoveries?.length
				? recoveries.reduce((latest, item) => {
						const itemDate = momentLocal(item.createdAt);
						return itemDate.isAfter(momentLocal(latest))
							? item.createdAt
							: latest;
				  }, recoveries[0].createdAt)
				: undefined;
			return {
				_id: repossessions.repossessionId,
				loanId: repossessions.loanId,
				internalId: repossessions.internalId,
				lastRecovery,
				recoveriesAmount: recoveries?.length ?? 0,
				lastLocation: gpsLocations[marker]?.createdAt,
				lastTileLocation: tileLocations[marker]?.createdAt,
				nextAction:
					repossessions.nextActions?.[repossessions.nextActions.length - 1] ??
					'-',
			};
		});
		setTableData(data);
		if (!selectedRepossessions?.length) {
			setSelectedRepossessions(data);
		}
	}, [repossessionsData, recoveriesData]);

	const onSort = (sortKey: any, direction: boolean) => {
		switch (sortKey) {
			case 'lastRecovery':
				setTableData((prev) => {
					const sorted = prev.sort((a, b) => {
						const dateA = momentLocal(a.lastRecovery);
						const dateB = momentLocal(b.lastRecovery);
						return direction ? dateA.diff(dateB) : dateB.diff(dateA);
					});
					return sorted;
				});
				return;

			case 'recoveriesAmount':
				setTableData((prev) => {
					const sorted = prev.sort((a, b) =>
						direction
							? a.recoveriesAmount - b.recoveriesAmount
							: b.recoveriesAmount - a.recoveriesAmount,
					);
					return sorted;
				});
				return;

			case 'lastLocation':
				setTableData((prev) => {
					const sorted = prev.sort((a, b) => {
						const dateA = momentLocal(a.lastLocation);
						const dateB = momentLocal(b.lastLocation);
						return direction ? dateA.diff(dateB) : dateB.diff(dateA);
					});
					return sorted;
				});
				return;
			case 'lastTileLocation':
				setTableData((prev) => {
					const sorted = prev.sort((a, b) => {
						const dateA = momentLocal(a.lastTileLocation);
						const dateB = momentLocal(b.lastTileLocation);
						return direction ? dateA.diff(dateB) : dateB.diff(dateA);
					});
					return sorted;
				});
				break;
			default:
				break;
		}
	};

	return (
		<div className="flex_content_col">
			<div className="flex_body">
				<ListTable
					data={tableData}
					canSelect
					rowClassName="br_none text_decoration_none"
					className="m_t_md"
					selecteds={selectedRepossessions}
					setSelecteds={setSelectedRepossessions}
					selectId="loanId"
					onSort={onSort}
					cols={[
						{
							label: 'Moto',
							weight: 4,
							render: (row: TableInfo) => (
								<Typography
									scale="medium"
									weight="400"
									textColor="neutral_700"
									className="text_center"
								>
									{row.internalId}
								</Typography>
							),
						},
						{
							label: 'Última visita',
							sortKey: 'lastRecovery',
							weight: 4,
							render: (row: TableInfo) => (
								<Typography
									scale="medium"
									weight="400"
									textColor="neutral_700"
									className="text_center"
								>
									{row.lastRecovery
										? momentLocal(row.lastRecovery).format('DD/MM/YYYY HH:mm')
										: '-'}
								</Typography>
							),
						},
						{
							label: 'Intentos previos',
							sortKey: 'recoveriesAmount',
							weight: 4,
							render: (row: TableInfo) => (
								<Typography
									scale="medium"
									weight="400"
									textColor="neutral_700"
									className="text_center"
								>
									{row.recoveriesAmount}
								</Typography>
							),
						},
						{
							label: 'Última Ubicación GPS',
							sortKey: 'lastLocation',
							weight: 4,
							render: (row: TableInfo) => (
								<Typography
									scale="medium"
									weight="400"
									textColor="neutral_700"
									className="text_center"
								>
									{row.lastLocation
										? momentLocal(row.lastLocation).format('DD/MM/YYYY HH:mm')
										: '-'}
								</Typography>
							),
						},
						{
							label: 'Última Ubicación Tile',
							sortKey: 'lastTileLocation',
							weight: 4,
							render: (row: TableInfo) => (
								<Typography
									scale="medium"
									weight="400"
									textColor="neutral_700"
									className="text_center"
								>
									{row.lastTileLocation
										? momentLocal(row.lastTileLocation).format(
												'DD/MM/YYYY HH:mm',
										  )
										: '-'}
								</Typography>
							),
						},
						{
							label: 'Accionable',
							weight: 4,
							render: (row: TableInfo) => (
								<Typography
									scale="medium"
									weight="400"
									textColor="neutral_700"
									className="text_center"
								>
									{row.nextAction}
								</Typography>
							),
						},
					]}
				/>
			</div>
			<div className="flex_footer p_md display_flex flex_justify_between bg_neutral_0">
				<Button
					className="w_20_per"
					variant="outline"
					onClick={() => setCreateRouteStep(CreateRouteSteps.allRepossessions)}
				>
					Anterior
				</Button>
				<Button
					className="w_20_per"
					disabled={selectedRepossessions.length < 1}
					onClick={() =>
						setCreateRouteStep(CreateRouteSteps.selectInterestPoints)
					}
				>
					Continuar
				</Button>
			</div>
		</div>
	);
};
